<template>
  <div v-if="loading" class="loading">Aguarde ...</div>
  <div v-else class="container-fluid">
    <div class="col-sm-12 text-left">
      <h3>
        <router-link to="/clientes/sup">Suporte</router-link> » 
        <router-link :to="selflink">{{this.$route.params.grupo}}</router-link>
      </h3>
      <small>{{clientes.length}} resultado(s) encontrados</small>
      <small v-if="this.$route.query.s"> que contém '{{this.$route.query.s}}'</small>
    </div>
    <table>  
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td class='lt500'>cnpj</td>
        <td>razao</td>
        <td>cidade</td>
        <td>dia</td>
        <td>valor</td>
        <td>contato</td>
        <td></td>
      </tr>
      <tr v-for="cliente in clientes">
        <td><a @click.prevent="select4edit(cliente.cod)" class="glyphicon glyphicon-pencil" title="Editar"></a></td>
        <td><a @click.prevent="select4agenda(cliente.cod)" class="glyphicon glyphicon-book" title="Agenda"></a></td>
        <td><a @click.prevent="select4addnew(cliente.grupo)" class="glyphicon glyphicon-plus" title="Adicionar filial não pagadora"></a></td>
        <td class="lt500" v-if="cliente.cobvalor>0"><span class="text-primary">{{maskCnpj(cliente.cnpj)}}</span></td>
        <td class="lt500" v-else>{{maskCnpj(cliente.cnpj)}}</td>
        <td>{{cliente.razao}}<br><small>{{cliente.fantasia}}</small></td>
        <td>{{cliente.endcidade !== '' ? cliente.endcidade : cliente.cobcidade}}</td>
        <td>{{cliente.cobdia}}</td>
        <td>{{maskMonetario(cliente.cobvalor, true)}}</td>
        <td>
            <span v-for="telefone in cliente.telefone" class="nowrap">{{maskTelefone(telefone.numero)}}</br></span>
        </td>
        <td><a href="" class="glyphicon glyphicon-pushpin" title="Anotações"></a></td>
      </tr>
    </table>
    <br><br><br>
  </div>
</template>

<script>
  import Mask from './Mask.js'
  export default {
    name: 'datalist',
    data () {
      return {
        loading: false,
        clientes: []
      }
    },
    methods: {
      load (params = '') {
        const url = './api/php/getcliente.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response.body)
            if (response.body.length > 0) {
              this.clientes = response.body
            } else {
              this.clientes = []
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      select4edit (cod) {
        this.$router.push({path: `/cliente/${cod}`})
      },
      select4agenda (cod) {
        this.$router.push({path: `/agenda/c/${cod}`})
      },
      select4addnew (grupo) {
        this.$router.push({path: `/cliente/${grupo}/0`})
      }
    },
    created: function () {
      this.maskCnpj = Mask.cnpj
      this.maskMonetario = Mask.monetario
      this.maskTelefone = Mask.telefone
      const grupo = this.$route.params.grupo
      const keyword = this.$route.query.s
      this.selflink = `/clientes/cob/${grupo}`
      this.load({'grupo': grupo, 'keyword': keyword})
    },
    watch: {
      '$route' (to, from) {
        const grupo = this.$route.params.grupo
        const keyword = this.$route.query.s
        this.load({'grupo': grupo, 'keyword': keyword})
      }
    }
  }
</script>

<style scoped>
    .container-fluid {
      width: 80vw;
      margin: auto;
    }
    table {
      font: 12px sans-serif;
      color: #333;
      border-collapse: collapse;
      outline: 2px solid #333;
      text-align: left;
      width: 80vw;
    }
    table tr {
      background: #fcfcfc;
    }
    table tr:nth-child(2n+1) {
      background: #f1f1f1;
    }
    table tr:hover{
      background: #ccc;
    }
    table tr:first-child {
      background: #333;
      color: #fff;
      text-transform: uppercase;
    }
    table tr td {
      padding: 5px;
    }
    table tr td small {
      color: #777;
    }
    a.glyphicon {
      text-decoration: none
    }
    .nowrap {
      white-space: nowrap;
    }
    @media (max-width: 499px) {
      .container-fluid {
        width: 100vw;
        margin: 0;
        padding: 0;
      }
      table {
        font: 10px sans-serif;
        width: 100vw;
      }
      .lt500 {
        display: none;
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/CliRelCobGrupo.vue